import {ConfEnv} from "../../../config/config";
import privateRequest from "../../../Infra/http/private.request";

const getTokenBetbyService = async (lang, currency) => {
  return privateRequest.get(`${ConfEnv.API_BETBY.URL_TOKEN}?lang=${lang}&currency=${currency}`);
};

export default getTokenBetbyService;
